// Converts undefined to null, because the API treats NULL value as disconnections
export const nullIfUndefined = (
  value: undefined | null | any,
): null | undefined | any => {
  if (value === undefined) {
    return null;
  }

  return value;
};
